import type {components} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type GeneratedEmploymentsResponse = components['schemas']['EmploymentsResponse'];

export type SelfEmploymentProvider = 'rocketwork' | 'quickwork' | 'alfa' | 'free_smz';

export type SelfEmploymentAgreementStatus = 'new' | 'sent' | 'signed';

export type SelfEmploymentAgreement = {
	/** URL страницы согласия на обработку ПД */
	link?: string | null;
	/** Статус согласия на обработку ПД */
	status?: SelfEmploymentAgreementStatus | null;
};

/** Дублирует `selfEmployment` + provider и agreement. */
export type SelfEmploymentProfile = NonNullable<GeneratedEmploymentsResponse['selfEmployment']> & {
	provider?: SelfEmploymentProvider;
	agreement?: SelfEmploymentAgreement;
	/** Внешний статус партнёра, например `BIND_REQUEST` — нужен доступ в «Мой налог». */
	externalStatus?: string | null;
};

export type EmploymentsResponse = GeneratedEmploymentsResponse & {
	selfEmploymentProfiles?: SelfEmploymentProfile[];
};

export type FetchEmploymentResponse = EmploymentsResponse;

/** GET `/executor_web/employment` — см. `paths['/executor_web/employment']` в auth swagger */
export function fetchEmployment(signal?: AbortSignal) {
	return axiosInstance.get<FetchEmploymentResponse>('employment', {signal});
}
